import { CulminatingCourseTransferCtrl } from './culminating-course-transfer.controller';

export const CulminatingCourseStepTransferComponent = {
  controller: CulminatingCourseTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./culminating-course-transfer.html'),
};
